import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FeatureSpecsEntities } from 'client/data/models/vehicle-v2';
import { formatPriceStringV2 } from 'site-modules/shared/utils/price-utils';
import { numberWithCommasForString } from 'site-modules/shared/utils/string';
import {
  FEATURE_DISPLAY_NAMES,
  NON_NUMBER_FEATURES,
  PRICED_CATEGORIES,
} from 'site-modules/features-specs/constants/features-specs';
import { FEATURE_SPEC_NAME_TOOLTIP_MAP, FEATURE_SPEC_TOOLTIP } from 'site-modules/shared/constants/features-specs';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

export function TableDataRow({
  feature: { name, value, price, description, valuePrefix },
  category = null,
  keyword = null,
}) {
  let tdContent = 'Standard';

  if (value || typeof price === 'number') {
    tdContent = (
      <Fragment>
        {valuePrefix}
        {typeof value === 'string' && !NON_NUMBER_FEATURES.includes(name)
          ? numberWithCommasForString(value)
          : value}{' '}
        {typeof price === 'number' ? `${price >= 0 ? '+' : ''}${formatPriceStringV2(price)}` : ''}
      </Fragment>
    );
  } else if (category && PRICED_CATEGORIES.includes(category)) {
    tdContent = 'Price not available';
  }

  const displayName = FEATURE_DISPLAY_NAMES[name] || name;

  return (
    <tr key={name}>
      <th scope="row" className="py-0_75 ps-0 pe-0_5">
        {keyword ? (
          <ContentFragment componentToUse="span">
            {displayName.replaceAll(
              new RegExp(`${keyword}`, 'gi'),
              str => `<span class="bg-blue-90 py-0_25">${str}</span>`
            )}
          </ContentFragment>
        ) : (
          displayName
        )}
        {!!FEATURE_SPEC_NAME_TOOLTIP_MAP[name] && (
          <PopoverItem
            placement="top"
            openTrackingParams={name.includes('MPGe') ? { value: 'MPGe' } : undefined}
            screenReaderTooltipLabel={displayName}
          >
            {FEATURE_SPEC_TOOLTIP[FEATURE_SPEC_NAME_TOOLTIP_MAP[name]]}
          </PopoverItem>
        )}
        {!!description && <div className="small">{description}</div>}
      </th>
      <td className="py-0_75 ps-0_5 pe-0" key="data-cell">
        {tdContent}
      </td>
    </tr>
  );
}

TableDataRow.propTypes = {
  feature: FeatureSpecsEntities.Feature.isRequired,
  category: PropTypes.string,
  keyword: PropTypes.string,
};
